import React from 'react';

import CartItemQty from './CartItemQty';
import CartItemShipping from './CartItemShipping';
import CartItemPrices from './CartItemPrices';
import CartItemMessages from './CartItemMessages';
import CartItemAgentItemBottom from '../agents/CartItemAgentItemBottom';
import CartItemAgentItemToolbar from '../agents/CartItemAgentItemToolbar';
import CartItemErrorDisplay from "./CartItemErrorDisplay";
import clsx from "clsx";
import CartItemPicture from "./CartItemPicture";
import CartItemDetail from "./CartItemDetail";
import AgentPriceWarning from "../agents/AgentPriceWarning";

/**
 * 2023-04 React modernized, item is camelcase here and below.
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function CartItemRow({index = 0, ...props}) {
  let {item, shoppingCart, currentAgent, forecasts = {}} = props;

  let forecast = forecasts?.[item.productId];

  const className = getItemClassList(item, index);

  return <div id={"item-" + item.id} className={className}>
    <div className="grid grid-cols-6 lg:grid-cols-12 gap-2">
      <CartItemPicture {...props} />
      <CartItemDetail {...props}  />
      <CartItemQty {...props} />
      <CartItemShipping {...props} forecast={forecast}/>
      <CartItemPrices {...props} />
    </div>

    <div>
      <CartItemMessages {...props} />
      <CartItemErrorDisplay {...props} />

      {currentAgent && <CartItemAgentItemBottom {...props} />}
      {currentAgent && <AgentPriceWarning {...props} />}
      {currentAgent && <CartItemAgentItemToolbar {...props} forecast={forecast}/>}
    </div>
  </div>

}

function getItemClassList(item, index=0) {
  let classes = ['cart-item my-2 py-2 border-b border-gray-400 border-dotted',
    (index % 2 === 1) ? 'bg-gray-50' : ''
  ];

  if (item.agentExtendedSavings > 0)
    classes.push('agent-adjusted');

  return clsx(classes);
}
